export default __webpack_public_path__ + "static/media/studyskills.fb684b3a.jpg";